import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ApplicationUnavailable = () => {
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    const tick = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          window.location.reload();
          return 30;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(tick);
  }, []);

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div>
      <Header />
      <main>
        <section className="banner"></section>
        <div className="container-1200 container-up">
          <div className="service-unavailable">
            <div className="service-unavailable-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                width="80"
                height="80"
                fill="none"
                stroke="#004087"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M32 6L4 58h56L32 6z" />
                <line x1="32" y1="24" x2="32" y2="40" />
                <circle cx="32" cy="48" r="2" fill="#004087" stroke="none" />
              </svg>
            </div>
            <h1>Application Unavailable</h1>
            <p className="service-unavailable-message">
              The European Vulnerability Database application encountered an
              unexpected error. We apologise for the inconvenience.
            </p>
            <p className="service-unavailable-sub">
              This page will automatically attempt to reload every 30 seconds.
            </p>
            <p className="service-unavailable-countdown">
              Reloading in <strong>{countdown}</strong> seconds
            </p>
            <button
              className="btn-secondary service-unavailable-retry"
              onClick={handleRetry}
            >
              Try Again
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ApplicationUnavailable;
